/*
 * @Description: 权限指令
 * @Author: James324
 * @Date: 2023-08-21 22:40:14
 * @LastEditors: James324
 * @LastEditTime: 2024-01-11 18:52:22
 */
import { Directive, DirectiveBinding } from 'vue';
import { GlobalStore } from '@/store';

const checkPermission = (el: HTMLElement, binding: DirectiveBinding) => {
    const { value } = binding;
    const globalStore = GlobalStore();
    const permissionBtn = Array.from(globalStore.buttons || []);
    const isSuperAdmin = globalStore.isSuperAdmin;

    // 超管拥有所有按钮权限
    if (isSuperAdmin) return;

    if (value && value instanceof Array) {
        if (!permissionBtn.length || !value.some((role: string) => permissionBtn.includes(role))) {
            el.parentNode && el.parentNode.removeChild(el);
        }
    } else {
        throw new Error("need roles! Like v-has=\"['order:search','feedback:search']\"");
    }
};

export const permission: Directive = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        checkPermission(el, binding);
    }
};
